<template>
    <div :class="['cms_slider_container', slidername]" :cms_slidername="slidername" :cms_sizearray="sizearray" v-show="Slides.length>0">
        <GrcDB ref="GRCDB"></GrcDB>

        <carousel 
        ref="slider1"
        :adjustableHeight="settings.adjustableHeight"
        :adjustableHeightEasing="settings.adjustableHeightEasing"
        :autoplay="settings.autoplay"
        :autoplayDirection="settings.autoplayDirection"
        :autoplayHoverPause="settings.autoplayHoverPause"
        :autoplayTimeout="settings.autoplayTimeout"
        :centerMode="settings.centerMode"
        :easing="settings.easing"
        :loop="settings.loop"
        :minSwipeDistance="settings.minSwipeDistance"
        :mouseDrag="settings.mouseDrag"
        :navigationClickTargetSize="settings.navigationClickTargetSize"
        :navigationEnabled="settings.navigationEnabled"
        :navigationNextLabel="settings.navigationNextLabel"
        :navigationPrevLabel="settings.navigationPrevLabel"
        :paginationActiveColor="settings.paginationActiveColor"
        :paginationColor="settings.paginationColor"
        :paginationPosition="settings.paginationPosition"
        :paginationEnabled="settings.paginationEnabled"
        :paginationPadding="settings.paginationPadding"
        :paginationSize="settings.paginationSize"
        :perPage="settings.perPage"
        :perPageCustom="settings.perPageCustom"
        :resistanceCoef="settings.resistanceCoef"
        :scrollPerPage="settings.scrollPerPage"
        :spacePadding="settings.spacePadding"
        :spacePaddingMaxOffsetFactor="settings.spacePaddingMaxOffsetFactor"
        :speed="settings.speed"
        >
            <slide v-for="(slideitem, slideindex) in Slides" :key="slideindex" v-on:slide-click="BannerClick(slideindex)">
            <div class="slideitem_container" v-html="slideitem.SlideContent">

            </div>
            </slide>
        </carousel>

    </div>
</template>

<script>

import GrcDB from './GrcDB.vue'

export default {
  name: 'grccms_slider',
  components: {
    GrcDB,
  },
  props: {
    cms_slidername: String,
    cms_sizearray: String
  },

  data () {
        return {
          slidername: this.cms_slidername,
          sizearray: this.cms_sizearray, 

          autoplay: false,
          autoplayTimeout: 1000,
          paginationEnabled:true,
          paginationPosition:"bottom-overlay",
          paginationColor:"red",
          Slides:[],

          CustomSizeArray:[],

          settings: {
            "adjustableHeight": false,
            "adjustableHeightEasing": "",
            "autoplay": false,
            "autoplayDirection": "forward",
            "autoplayHoverPause": true,
            "autoplayTimeout": 2000,
            "centerMode": false,
            "easing": "ease",
            "loop": false,
            "minSwipeDistance": 8,
            "mouseDrag": true,
            "navigationClickTargetSize": 8,
            "navigationEnabled": true,
            "navigationNextLabel": "<i class='fal fa-chevron-right' style='font-size:34px; color:#323232;'></i>",
            "navigationPrevLabel": "<i class='fal fa-chevron-left' style='font-size:34px; color:#323232;'></i>",
            "paginationActiveColor": "black",
            "paginationColor": "green",
            "paginationPosition": "bottom-overlay",
            "paginationEnabled": true,
            "paginationPadding": 10,
            "paginationSize": 10,
            "perPage": 2,
            "perPageCustom": [[200, 1], [600, 1], [1000, 1]],
            "resistanceCoef": 20,
            "scrollPerPage": true,
            "spacePadding": 0,
            "spacePaddingMaxOffsetFactor": 0,
            "speed": 500
          },

        }
  },
  model: {

  },  
  methods:{

  BannerClick(pIndex)
    {

    },

    async Init()
    {
        var QP = {
            sSessionID: "[APPSESSIONID]",
            sAlias: GRCAPP_GetParameters.ALIAS,
            sSliderName: this.slidername,
        };
        var Q;
        await this.$refs.GRCDB.GetData("CMS_GetSlider", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            console.log(Q);
            return;
        }

        this.settings = JSON.parse(Q.SETTINGS[0].settings);

        this.Slides = Q.SLIDES;
    },


  },

  created()
  {
    if (typeof this.slidername == "undefined")
    {
      this.slidername = "";
    }

    /*
    if (typeof this.sizearray == "undefined")
    {
      this.sizearray = "[[200, 1], [600, 1], [1000, 1]]";
    }
    */

    if (this.slidername == "") { return; }

    //this.CustomSizeArray = JSON.parse(this.sizearray);

 },

 mounted()
 {
    this.Init();
 },

}


</script>


<style scoped>


</style>
